/* eslint-disable react-hooks/exhaustive-deps */
import type { FC, ReactNode } from 'react'
import { createContext, useState, useContext, useMemo } from 'react'

import type { Classification } from './types'

type VendorInfo = { vendorId: number | null; ecomCustomerId: number | null }
type DescriptionInfo = { isCustom: boolean; description: string }

type NewPolicyContext = {
  selectedCustomerId: [number | null, (v: number | null) => void]
  selectedName: [string, (v: string) => void]
  selectedVendorInfo: [VendorInfo, (arg: VendorInfo) => void]
  selectedCustomerHeadId: [number | null, (v: number | null) => void]
  descriptionInfo: [DescriptionInfo, (arg: DescriptionInfo) => void]
  selectedClassifications: [Classification[] | null, (v: Classification[] | null) => void]
}

const Context = createContext<NewPolicyContext>({
  selectedClassifications: [null, () => {}],
  selectedCustomerId: [null, () => {}],
  selectedCustomerHeadId: [null, () => {}],
  selectedVendorInfo: [{ vendorId: null, ecomCustomerId: null }, () => {}],
  descriptionInfo: [{ isCustom: false, description: '' }, () => {}],
  selectedName: ['', () => {}],
})

export const PolicyContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const selectedClassifications = useState<Classification[] | null>(null)
  const selectedCustomerId = useState<number | null>(null)
  const selectedCustomerHeadId = useState<number | null>(null)
  const selectedVendorInfo = useState<VendorInfo>({ vendorId: null, ecomCustomerId: null })
  const descriptionInfo = useState<DescriptionInfo>({ isCustom: false, description: '' })
  const selectedName = useState('')

  const value = useMemo(
    () => ({
      selectedClassifications,
      selectedCustomerId,
      selectedVendorInfo,
      descriptionInfo,
      selectedCustomerHeadId,
      selectedName,
    }),
    [
      JSON.stringify(selectedClassifications[0]),
      selectedCustomerId[0],
      selectedVendorInfo[0].ecomCustomerId,
      descriptionInfo[0].description,
      selectedCustomerHeadId[0],
      selectedName[0],
    ]
  )

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export const useNewPolicyContext = () => useContext(Context)
